/**
 * Shared brand chrome — logo mark, nav brand block, and footers.
 * Used by both the landing page and the case-study pages so the two
 * stay visually consistent (previously the case studies used a bare "▲").
 */

export function LogoMark() {
  return (
    <svg viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="tpWing" x1="6" y1="17" x2="35" y2="6" gradientUnits="userSpaceOnUse">
          <stop className="lg-light" />
          <stop className="lg-mid" offset="1" />
        </linearGradient>
        <linearGradient id="tpFold" x1="18" y1="37" x2="35" y2="6" gradientUnits="userSpaceOnUse">
          <stop className="lg-mid" />
          <stop className="lg-dark" offset="1" />
        </linearGradient>
      </defs>
      <path d="M4.5 30 L11.5 26.5" className="lg-dash" strokeWidth="2.6" strokeLinecap="round" opacity="1" />
      <path d="M3.5 35.5 L9 32.8" className="lg-dash" strokeWidth="2.6" strokeLinecap="round" opacity="0.72" />
      <path d="M35 6 L6 17 L20 22 Z" fill="url(#tpWing)" />
      <path d="M35 6 L20 22 L18 37 Z" fill="url(#tpFold)" />
    </svg>
  )
}

/** Nav brand block: logo mark + ThroughPilot / Zohaib labels. */
export function Brand() {
  return (
    <a className="brand" href="/">
      <span className="mark"><LogoMark /></span>
      <span>
        <span className="bname">ThroughPilot</span>
        <span className="bsub">Product Engineering</span>
      </span>
    </a>
  )
}

/** Landing-page footer. */
export function SiteFooter() {
  return (
    <div className="footer">
      <div className="fbrand"><span className="fmark"><LogoMark /></span> ThroughPilot</div>
      <div>Senior product engineering for AI-era builds</div>
      <div className="copyright-line"><span className="copyright-mark">©</span><span>2026 ThroughPilot</span></div>
    </div>
  )
}

/** Case-study page footer. */
export function CaseFooter() {
  return (
    <div className="foot">ThroughPilot · AI-era product engineering</div>
  )
}
